import { render, staticRenderFns } from "./AndroidHealthStatistics.vue?vue&type=template&id=2bd31d59&scoped=true"
import script from "./AndroidHealthStatistics.vue?vue&type=script&lang=js"
export * from "./AndroidHealthStatistics.vue?vue&type=script&lang=js"
import style0 from "./AndroidHealthStatistics.vue?vue&type=style&index=0&id=2bd31d59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd31d59",
  null
  
)

export default component.exports